var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.5 28H36C34.4087 28 32.8826 27.3679 31.7574 26.2426C30.6321 25.1174 30 23.5913 30 22V4.5C30 4.36739 29.9473 4.24021 29.8536 4.14645C29.7598 4.05268 29.6326 4 29.5 4H18C15.8783 4 13.8434 4.84285 12.3431 6.34315C10.8429 7.84344 10 9.87827 10 12V52C10 54.1217 10.8429 56.1566 12.3431 57.6569C13.8434 59.1571 15.8783 60 18 60H46C48.1217 60 50.1566 59.1571 51.6569 57.6569C53.1571 56.1566 54 54.1217 54 52V28.5C54 28.3674 53.9473 28.2402 53.8536 28.1464C53.7598 28.0527 53.6326 28 53.5 28ZM42 48H22C21.4696 48 20.9609 47.7893 20.5858 47.4142C20.2107 47.0391 20 46.5304 20 46C20 45.4696 20.2107 44.9609 20.5858 44.5858C20.9609 44.2107 21.4696 44 22 44H42C42.5304 44 43.0391 44.2107 43.4142 44.5858C43.7893 44.9609 44 45.4696 44 46C44 46.5304 43.7893 47.0391 43.4142 47.4142C43.0391 47.7893 42.5304 48 42 48ZM42 38H22C21.4696 38 20.9609 37.7893 20.5858 37.4142C20.2107 37.0391 20 36.5304 20 36C20 35.4696 20.2107 34.9609 20.5858 34.5858C20.9609 34.2107 21.4696 34 22 34H42C42.5304 34 43.0391 34.2107 43.4142 34.5858C43.7893 34.9609 44 35.4696 44 36C44 36.5304 43.7893 37.0391 43.4142 37.4142C43.0391 37.7893 42.5304 38 42 38Z",
    fill: "url(#paint0_linear_8437_37218)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4025 23.5739L34.4263 5.5976C34.3913 5.56285 34.3468 5.53921 34.2985 5.52965C34.2501 5.52009 34.2 5.52504 34.1545 5.54387C34.1089 5.56271 34.0699 5.59459 34.0425 5.63551C34.015 5.67643 34.0002 5.72456 34 5.77385V22.0001C34 22.5305 34.2107 23.0392 34.5858 23.4143C34.9609 23.7894 35.4696 24.0001 36 24.0001H52.2262C52.2755 23.9999 52.3237 23.9851 52.3646 23.9576C52.4055 23.9302 52.4374 23.8912 52.4562 23.8456C52.4751 23.8001 52.48 23.75 52.4705 23.7016C52.4609 23.6533 52.4373 23.6088 52.4025 23.5739Z",
    fill: "url(#paint1_linear_8437_37218)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8437_37218",
    x1: 43.2245,
    y1: 110,
    x2: 72.9357,
    y2: 106.352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E2C66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1741BC",
    stopOpacity: 0.83
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8437_37218",
    x1: 47.9507,
    y1: 40.4958,
    x2: 60.3123,
    y2: 38.5641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E2C66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1741BC",
    stopOpacity: 0.83
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/FileIcon.b5ad9fcac4606ce6531212dcba79cf0c.svg";
export { ForwardRef as ReactComponent };